export enum ResourceSortAttribute {
  Title = 'Title',
  CreatedAt = 'CreatedAt',
  ResourceType = 'ResourceType',
  UpdatedAt = 'UpdatedAt',
  LastUsed = 'LastUsed',
  UseCount = 'UseCount',
}
